
import { Card, Col, Divider, Form, Input, Row, Space, Select } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import ButtonAction from 'components/Common/ButtonAction';
import { ButtonAdd } from 'components/Common/Buttons';
import useTopbarTitleHooks from 'hooks/useTopbarTitleHooks';
import CustomAntdTable from 'components/Common/CustomAntdTable';
import { dismissToast, errorToast, successToast, loadingToastId } from 'utils/Toast';
import Constant from 'utils/Constants';
import { sorterTable } from 'utils/Helper';
import useIsMobileHooks from 'hooks/useIsMobileHooks';
import useAccessPermissionHook from 'hooks/useAccessPermissionHook';
import { PRIVILEGE_ID } from 'utils/AccessPermissionConfig';
import SkeletonPage from 'components/Common/SkeletonPage';
import { ButtonAdvanceFilter } from 'components/Common/ButtonAdvanceFilter';
import Error403 from 'components/Error/Error403';
import BaseAdvanceFilter from 'components/CustomDrawer/BaseAdvanceFilter';
import CellTable from 'components/Common/CellTable';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant';
import usePositionRepo from "../../../services/repo/usePositionRepo";
import useOrgRepo from "../../../services/repo/useOrgRepo";
import useDeptRepo from "../../../services/repo/useDepartmentRepo";
import useDivRepo from "../../../services/repo/useDivisionRepo";
import PositionFilterForm from './PositionFilterForm'; // sesuaikan path jika berbeda
import SetupModuleBanner from 'components/Onboarding/SetupModuleBanner';

export default function Position() {

    useTopbarTitleHooks("Position");
    const { isLoading: isLoadingPosList, getPositionList, deletePosition } = usePositionRepo(false)
    const { isLoading: isLoadingDeptList, getDepartmentList, isLoadingDelete } = useDeptRepo(false);
    const { isLoading: isLoadingOrgList, getOrgList } = useOrgRepo(false)
    const { isLoading: isLoadingDivList, getDivisionList } = useDivRepo(false)


    const isMobile = useIsMobileHooks()
    const [form] = Form.useForm()
    const navigate = useNavigate();
    const [data, setData] = useState()
    const [totalData, setTotalData] = useState(0)
    const [isOpenAdvanceFilter, setIsOpenAdvanceFilter] = useState(false)

    const { isHasPrivilege } = useAccessPermissionHook()
    const isLoadingPrivilege = useRef(true)
    const hasPrivilegePage = useRef(true)
    const [isLoadedPrivilege, setIsLoadedPrivilege] = useState(false)
    const [showButtonAdd, setShowButtonAdd] = useState(false)

    const [filters, setFilters] = useState({
        posCode: "",
        posName: "",
        deptId: null,
        divId: null,
        orgId: null,
        status: ""
    })

    const [tableParams, setTableParams] = useState({
        pageNumber: 1,
        pageSize: 10,
        filter: { ...filters },
        orderBy: "posId",
        isAscending: true
    });

    const onSearch = (value) => {
        setTableParams(prev => ({
            ...prev,
            pageNumber: 1,
            filter: {
                ...filters
            }
        }))
    };

    const onSearchClick = () => {
        onSearch()
        setIsOpenAdvanceFilter(false)
    }

    const fetchData = async () => {

        const payload = {
            ...tableParams
        }
        const res = await getPositionList(payload)
        if (res?.detail == 'OK' && res?.status === 200) {
            setData(res?.data?.content)
            setTotalData(res?.data?.totalElements)
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams(prevParams => ({
            ...prevParams,
            pageNumber: pagination?.current,
            pageSize: pagination?.pageSize,
            orderBy: sorter?.field || prevParams?.orderBy,
            isAscending: sorterTable(sorter?.order, prevParams?.isAscending)
        }));
        if (pagination.pageSize !== tableParams?.pageSize) {
            setData([]);
        }
    };

    const handleAdd = () => {
        navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.organization.position.create);
    }

    const handleEdit = async (data) => {
        const key = 'loadingEdit';
        loadingToastId(Constant.message.loading, key)
        navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.organization.position.edit(data?.posId));
        dismissToast(key)
    }

    const handleDelete = async (record) => {
        const key = 'deletePosition';
        try {

            debugger

            loadingToastId(Constant.message.loading, key)

            const response = await deletePosition({ posId: record.posId });

            if (response?.status === 200 && response?.detail === 'OK') {
                successToast(Constant.message.deleteDataSuccess);
                fetchData(); // refresh table
            } else {
                errorToast(Constant.message.deleteDataFail);
            }
        } catch (error) {
            console.error('Error:', error);
            errorToast(Constant.message.deleteDataFail);
        } finally {
            dismissToast(key); //tambahkan ini agar loading hilang
        }
    };

    const fetchCheckPrivilege = async () => {
        setShowButtonAdd('Add')
        isLoadingPrivilege.current = false
        hasPrivilegePage.current = true;
        setIsLoadedPrivilege(true)
        fetchData();
        dismissToast(PRIVILEGE_ID.AddEditPosition);
    }

    const [orgOptions, setOrgOptions] = useState([])
    const fetchDataOrg = async () => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            orderBy: "orgId",
            isAscending: true,
            filter: {
                orgId: null,
                orgName: "",
                status: "true",
            },
        }

        const res = await getOrgList(payload)
        if (res?.detail == 'OK' && res?.status === 200) {
            setOrgOptions(() => {
                return res?.data?.content.map(item => {
                    return { label: item?.orgName, value: item?.orgId }
                })
            })
        }
    }

    const [divOptions, setDivOptions] = useState([])
    const fetchDataDivision = async (orgId) => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            filter: {
                divCode: "",
                divName: "",
                orgId: orgId,
                divId: null,
                status: "true",
            },
            orderBy: "divCode",
            isAscending: true
        }
        setDivOptions([])

        const res = await getDivisionList(payload)
        if (res?.detail == 'OK' && res?.status === 200) {
            setDivOptions(() => {
                return res?.data?.content.map(item => {
                    return {
                        value: item?.divId,
                        label: item?.divName
                    }
                })
            })
        }
    }

    const [deptOptions, setDeptOptions] = useState([])
    const fetchDataDepartment = async (divId) => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            filter: {
                deptId: null,
                deptName: "",
                divId: divId,
                status: "true"
            },
            orderBy: "deptName",
            isAscending: true
        }

        setDeptOptions([])
        const res = await getDepartmentList(payload)
        if (res?.detail === 'OK' && res?.status === 200) {
            setDeptOptions(() =>
                res?.data?.content.map((item) => ({
                    label: item?.deptName,
                    value: item?.deptId
                }))
            )
        }
    }


    useEffect(() => {
        fetchCheckPrivilege()
         fetchDataOrg()
    }, [])

    useEffect(() => {

        if (isLoadedPrivilege) {
            fetchData();
        }
    }, [JSON.stringify(tableParams)]);

    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (isLoadedPrivilege && !isMobile) {
                onSearch()
            }
        }, Constant.delayFilter);
        return () => clearTimeout(timeOutId);
    }, [filters]);

    const filterUI = () => (
        <PositionFilterForm
            form={form}
            filters={filters}
            setFilters={setFilters}
            orgOptions={orgOptions}
            divOptions={divOptions}
            deptOptions={deptOptions} // ✅ baru
            setDivOptions={setDivOptions}
            setDeptOptions={setDeptOptions} // ✅ baru
            isLoadingOrgList={isLoadingOrgList}
            isLoadingDivList={isLoadingDivList}
            isLoadingDeptList={isLoadingDeptList} // ✅ baru
            fetchDataDivision={fetchDataDivision}
            fetchDataDepartment={fetchDataDepartment} // ✅ baru
        />
    )


    const columns = [
        {
            title: 'Action',
            key: 'action',
            width: "40px",
            render: (_, record) => {
                const buttons = showButtonAdd ? ['edit', 'delete'] : ['delete']
                return (
                    <ButtonAction
                        buttons={buttons}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                        data={record}
                        loadingDelete={isLoadingDelete}
                    />
                )
            }
        },
        {
            title: 'Organization',
            dataIndex: 'orgName',
            sorter: true,
            width: "200px",
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Division',
            dataIndex: 'divName',
            sorter: true,
            width: "200px",
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Department',
            dataIndex: 'deptName',
            sorter: true,
            width: "200px",
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Code',
            dataIndex: 'posCode',
            sorter: true,
            width: "150px",
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Name',
            dataIndex: 'posName',
            width: "200px",
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Submitted By',
            dataIndex: 'submissionUserFullName',
            sorter: false,
            width: "150px",
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Approved By',
            dataIndex: 'approverUserFullName',
            sorter: false,
            width: "150px",
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Status',
            dataIndex: 'status',
            width: "100px",
            render: (data) => <CellTable data={String(data).toLowerCase() === "true" ? "Active" : "Inactive"} />
        }
    ];
    return (
        <>
            <SetupModuleBanner />
            {hasPrivilegePage.current ?
                <Space direction="vertical" size="large" className='space-vertical-flex'>
                    <Card size="big" bordered={false}>
                        {isLoadingPrivilege.current ? <SkeletonPage /> :
                            <>
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={20} xl={18}>
                                        {showButtonAdd && <ButtonAdd onClick={handleAdd} />}
                                    </Col>
                                </Row>
                                <Divider dashed className='mb-1 mt-1' />

                                {isMobile ?
                                    <ButtonAdvanceFilter onClick={() => setIsOpenAdvanceFilter(true)} />
                                    : filterUI()
                                }

                                <CustomAntdTable
                                    columns={columns}
                                    dataSource={data}
                                    rowKey={"posId"}
                                    tableParam={tableParams}
                                    totalData={totalData}
                                    loading={isLoadingPosList}
                                    onChange={handleTableChange}
                                // null
                                // isOpenDrawer={isOpenDrawer}
                                // idDataHighlight={idHighlightRow}
                                />
                            </>
                        }
                    </Card>
                </Space> : (<Error403 />)
            }



            {isOpenAdvanceFilter &&
                <BaseAdvanceFilter
                    onClose={() => setIsOpenAdvanceFilter(false)}
                    onSearchClick={onSearchClick}>
                    {filterUI()}
                </BaseAdvanceFilter>}
        </>
    )
}
